import en_us from "@/i18n/lang/en_us";
import zh_cn from "@/i18n/lang/zh_cn";
import ja_jp from "@/i18n/lang/ja_jp";

export default {
  en_us,
  zh_cn,
  ja_jp,
};
